import {
  Box,
  Button,
  IconButton,
  Paper,
  TableBody,
  TableCell,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Modal,
  Container,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "../../Component/spinner/spinner";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ReactPaginate from "react-paginate";
import placeholder from "../../assets/images/placeholder/placeholder.png";
import { toast } from "react-toastify";
import {
  useDeleteSpotlightByIdMutation,
  useEnableDisableSpotlightByIdMutation,
  useGetAllSpotlightPaginationMutation,
} from "../../app/services/spotlightService";

import { useSelector } from "react-redux";
import { selectCurrentScope } from "../../app/auth/authSlice";
import Divider from '@mui/material/Divider';

//Modal usage
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  minWidth: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  padding: 4,
  overflow: "scroll",
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  placeItems: "center",
  width: '500px',
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  padding: 2,
  height: "70vh",
  // width:"100%",
  zIndex: "9999999",
};
function EnhancedTableHead() {
  const headCells = [
    {
      id: "heading",
      numeric: false,
      disablePadding: true,
      label: "Heading",
    },
    {
      id: "image",
      numeric: true,
      disablePadding: false,
      label: "Image",
    },
    {
      id: "content",
      numeric: true,
      disablePadding: false,
      label: "Content",
    },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

const SpotlightTable = () => {
  const [loading, setLoading] = useState(true);
  const [allSpotlight, setAllSpotlight] = useState([]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [getAllSpotlightPagination] = useGetAllSpotlightPaginationMutation();
  const [enableDisableSpotlight] = useEnableDisableSpotlightByIdMutation();
  const [deleteSpotlight] = useDeleteSpotlightByIdMutation();
  const [selectedId, setSelectedId] = useState("");
  const [selectedSpotlight, setSelectedSpotlight] = useState(null);
  const memberScope = useSelector(selectCurrentScope);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");


  //get all pagination for testimonial
  const getAllPagination = useCallback(() => {
    var data = {
      page: page + 1,
      itemsPerPage: rowsPerPage,
      role: memberScope
    };
    setLoading(true);
    getAllSpotlightPagination(data).then((res) => {
      setLoading(false);
      if (res.data?.status) {
        setTotalItems(res?.data?.data?.totalCount || 0);
        setAllSpotlight(res.data?.data?.spotLightDetails || []);
      } else {
        setAllSpotlight([]);
      }
    });
  }, [getAllSpotlightPagination, page, rowsPerPage, memberScope]);

  //useEffect
  useEffect(() => {
    getAllPagination();
  }, [getAllPagination]);

  // Enable/Disable
  const handleEnableDisable = (id) => {
    setLoading(true);
    enableDisableSpotlight(id)
      .then((res) => {
        setLoading(false);
        if (res?.data?.status) {
          getAllPagination();
          if (res.data?.data.isDeleted === 0) {
            toast.success("Spotlight Enabled");
          } else {
            toast.error("Spotlight Disabled");
          }
        } else {
          getAllPagination();
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen1 = (spotlight) => {
    setSelectedSpotlight(spotlight);
    setOpen1(true);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleDelete = () => {
    setLoading(true);
    deleteSpotlight(selectedId)
      .then((res) => {
        setLoading(false);
        handleClose();
        if (res?.data?.status) {
          const updatedTotalItems = totalItems - 1;
          const newPageCount = Math.ceil(updatedTotalItems / rowsPerPage);

          // If current page becomes empty, go to the previous page
          if (page >= newPageCount && newPageCount > 0) {
            setPage(newPageCount - 1);
          } else {
            getAllPagination(); // Refresh current page
          }

          toast.success("Spotlight Deleted successfully !!!");
          setTotalItems(updatedTotalItems); // Update totalItems state
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        toast.error("Something went wrong.");
      });
  };

  const handlePageClick = ({ selected }) => {
    setPage(selected);
  };

  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };
  //calculate pagecount
  const pageCount = Math.ceil(totalItems / rowsPerPage);

  return (
    <>
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">
            Spotlights List
          </h2>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="p-md-5 p-3 overallPadding ">
          <div sx={{ marginBottom: "50px" }}>
            <div className="text-end w-100">

              <Link
                to={
                  memberScope === "PORTAL_SUPER_ADMIN"
                    ? "/admin/add-edit-spotlight"
                    : "/assistantadmin/add-edit-spotlight"
                }
              >
                <Button
                  variant="contained"
                  className="menus-color mb-3"
                  type="submit"
                  style={{
                    backgroundColor: "#1769aa",
                    color: "#fff",
                    padding: "6px 16px",
                    borderRadius: "0px",
                    textTransform: "uppercase"
                  }}
                >
                  Add Spotlight
                </Button>
              </Link>
            </div>
            <TableContainer sx={{ boxShadow: 0 }} component={Paper}>
              <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <EnhancedTableHead />
                <TableBody>
                  {allSpotlight?.length > 0 ? (
                    allSpotlight.map((spotlight, index) => (
                      <TableRow
                        hover
                        key={spotlight._id}
                        sx={{
                          cursor: "pointer",
                          backgroundColor: "white",
                        }}
                      >
                        <TableCell align="center">
                          {spotlight.heading.length > 30 ? (<>{spotlight?.heading.slice(0, 30)}...</>) : <>{spotlight?.heading}</>}
                        </TableCell>
                        <TableCell align="center" style={{ width: "200px" }}>
                          <img
                            src={
                              spotlight.image
                                ? `${spotlight.image}?t=${new Date().getTime()}`
                                : placeholder
                            }
                            className="w-100"
                            alt="Spotlight"
                          />
                        </TableCell>
                        <TableCell align="center" sx={{ width: "300px" }}>
                          {spotlight.content.slice(0, 200)}...
                        </TableCell>
                        <TableCell align="center">
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            gap="8px"
                            flexWrap="wrap"
                          >
                            {!(spotlight.isDeleted === 2) && (
                              <>
                                <Tooltip title="View" placement="top">
                                  <IconButton
                                    aria-label="ViewIcon"
                                    onClick={() => handleOpen1(spotlight)}
                                  >
                                    <VisibilityIcon className="icon-vieweye-color" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit" placement="top">
                                  <IconButton aria-label="EditIcon">
                                    <Link
                                      to={
                                        memberScope === "PORTAL_SUPER_ADMIN"
                                          ? "/admin/add-edit-spotlight/" + spotlight._id
                                          : "/assistantadmin/add-edit-spotlight/" + spotlight._id

                                      }
                                    >
                                      {!(spotlight.isDeleted === 2) && (
                                        <EditIcon style={{ color: "green" }} />
                                      )}
                                    </Link>
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}

                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                flexWrap: "wrap",
                              }}
                            >
                              {spotlight?.isDeleted === 0 ? (
                                <Tooltip title="Enable" placement="top">
                                  <IconButton
                                    aria-label="enable"
                                    onClick={() => {
                                      handleEnableDisable(spotlight._id);
                                    }}
                                  >
                                    <LockOpenIcon style={{ color: "green" }} />
                                  </IconButton>
                                </Tooltip>
                              ) : spotlight?.isDeleted === 2 ? (
                                <Tooltip title="Disable" placement="top">
                                  <IconButton
                                    aria-label="disable"
                                    onClick={() => {
                                      handleEnableDisable(spotlight._id);
                                    }}
                                  >
                                    <LockIcon style={{ color: "red" }} />
                                  </IconButton>
                                </Tooltip>
                              ) : null}
                              <Tooltip title="Delete" placement="top">
                                <IconButton
                                  aria-label="delete"
                                  onClick={() => handleOpen(spotlight._id)}
                                >
                                  <DeleteIcon style={{ color: "red" }} />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow
                      sx={{
                        cursor: "pointer",
                        backgroundColor: "white",
                      }}
                    >
                      <TableCell colSpan={4} align="center">
                        Will Be Added Shortly
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <Modal
                  open={open1}
                  onClose={handleClose1}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={style1}
                    className="d-flex align-items-center flex-column gap-3 overflow-x-hidden"
                  >
                    <Container maxWidth={false} sx={{ px: 3 }}>
                      <Box className="d-flex justify-content-between py-2">
                        <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                          View Spotlights
                        </Typography>
                        <IconButton onClick={handleClose1} aria-label="Close">
                          <CloseIcon />
                        </IconButton>
                      </Box>

                      {/* Centered Divider */}
                      <Box display="flex" justifyContent="center" width="100%">
                        <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                      </Box>

                      <div className="d-flex justify-content-center">
                        <h2
                          className="alata-regular fs-5 text-center py-2"
                          style={{ color: "#611f1e" }}
                        >
                          {selectedSpotlight?.heading}
                        </h2>
                      </div>
                      <div className="d-flex justify-content-center">
                        <div >
                          <img
                            src={selectedSpotlight?.image}
                            className="img-fluid"
                            alt="img"
                          />
                        </div>
                      </div>
                      <div className="text-justify" >
                        <p className="alata-regular spotlight-text-justify p-0 my-3" >
                          {selectedSpotlight?.content}
                        </p>
                      </div>
                    </Container>
                  </Box>
                </Modal>

                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={style}
                    className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
                  >

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                        Confirmation
                      </Typography>
                      <IconButton onClick={handleClose} aria-label="Close">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <Box display="flex" justifyContent="center" width="100%">
                      <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                    </Box>
                    <Typography
                      id="modal-modal-title"
                      style={{ color: "#611f1e" }}
                      variant="h6"
                      component="h2"
                      className="content-font"
                    >
                      Are You Surely Want to Delete this Spotlight?
                    </Typography>
                    {/* <Box display="flex" justifyContent="center" width="100%">
                      <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                    </Box> */}
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        variant="outlined"
                        className="content-font"
                        style={{

                          color: "#dc3545",
                          border: "1px solid #dc3545",
                          padding: "5px 15px",
                          borderRadius: "0px",
                        }}
                        onClick={handleClose}
                      >
                        No
                      </Button>
                      <Button
                        className="mx-2 content-font"
                        variant="contained"
                        style={{
                          backgroundColor: "#2e7d32",
                          color: "white",
                          padding: "5px 15px",
                          borderRadius: "0px",
                        }}
                        onClick={() => handleDelete()}
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>
              </Table>
            </TableContainer>
            <br />
            {allSpotlight.length > 0 ? (
              <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                <div className="mb-2 mb-md-0">
                  <div className="d-flex gap-2">
                    <input
                      type="number"
                      min={1}
                      placeholder="Page no."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                    />
                    <div className="goPage cursor-pointer" onClick={handlePageChange}>
                      <h5 className="p-2 m-0">Go</h5>
                    </div>
                  </div>
                  {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                </div>
                {/* Pagination in the Center */}
                <div className="my-3 my-md-0">
                  <ReactPaginate
                    pageCount={pageCount} // Calculate total pages
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                    nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
                    disabledClassName={"disablebtn"}
                    forcePage={page}
                  />
                </div>
                <div className="mb-2 mb-md-0">
                  <FormControl variant="outlined">
                    <Select
                      className="itemsperpage"
                      value={rowsPerPage}
                      onChange={(e) => {
                        const value = e.target.value;
                        setRowsPerPage(value);
                        setError('')
                        setSearchTerm('');
                        setPage(0)
                      }}
                      MenuProps={{
                        MenuListProps: {
                          sx: {
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                      }}
                    >
                      <MenuItem value={10} className="Event-menu">10</MenuItem>
                      <MenuItem value={20} className="Event-menu">20</MenuItem>
                      <MenuItem value={50} className="Event-menu">50</MenuItem>
                      <MenuItem value={100} className="Event-menu">100</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <br />
        </div>
      )}
    </>
  );
};

export default SpotlightTable;
